import React from 'react';
import TemplateCollections from '../../components/crm/TemplateCollections';
import { DEFAULT_HR_SECTIONS } from '../../utils/hrMaterials';

const HR_CONFIG = {
  title: 'HR Collections',
  pillar: 'HR',
  structureId: 'hr',
  defaultSections: DEFAULT_HR_SECTIONS,
  backTo: '/crm',
  accent: {
    tabActive: 'bg-yellow-500',
    spinner: 'border-yellow-500',
    button: 'bg-yellow-500 hover:bg-yellow-600',
  },
  sectionPlaceholder: 'e.g. Hiring Materials',
  itemPlaceholder: 'e.g. PTO Request Form',
};

const HRCollections = () => <TemplateCollections config={HR_CONFIG} />;

export default HRCollections;
